import React from "react";
import { Save } from "lucide-react";
import { Modal } from "../../components/Modal";

export function Input({ label, value, set, type = "text" }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-wider text-slate-600 mb-1 block">{label}</label>
      <input type={type} value={value ?? ""} onChange={(e) => set(e.target.value)} className="h-9 w-full border border-slate-300 px-2 font-mono text-sm" />
    </div>
  );
}

export function SimpleDialog({ title, onClose, onSave, children }) {
  return (
    <Modal
      open
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <button onClick={onClose} className="h-9 px-4 rounded-full border border-slate-300 text-xs uppercase tracking-wider font-semibold">Cancel</button>
          <button onClick={onSave} className="h-9 px-4 rounded-full bg-brand-blue text-white text-xs uppercase tracking-wider font-semibold inline-flex items-center gap-2 hover:bg-brand-blue-dark" data-testid="dialog-save-button">
            <Save size={14} /> Save
          </button>
        </>
      }
    >
      <div className="space-y-3">{children}</div>
    </Modal>
  );
}
